import React from "react";
import { useFormikContext } from "formik";

import LayerCard from "../elements/LayerCard";
import RadioCardGroup from "../../../shared/RadioCardGroup";
import type { L1Dimension, TargetFormValues } from "../TargetBuilderPanel.types";
import { L1_OPTIONS } from "../TargetBuilderPanel.types";
import { useLModelCascade } from "../hooks/useLModelCascade";

/**
 * L1 — Behavioral Dimension picker.
 * Selecting a dimension cascades-reset L2, sub-config, L3, and teaching procedure.
 */
const L1DimensionSelector: React.FC = () => {
  const { values } = useFormikContext<TargetFormValues>();
  const { setL1 } = useLModelCascade();

  return (
    <LayerCard
      title="What kind of behavior is this?"
      description="Select the dimension that best describes what you want to measure and change"
    >
      <RadioCardGroup<L1Dimension>
        ariaLabel="Behavioral dimension"
        value={values.l1_dimension}
        options={L1_OPTIONS}
        onChange={setL1}
      />
    </LayerCard>
  );
};

export default L1DimensionSelector;
